<template>
  <div class="cateringOrder">
    <topNav :title="$t('cateringOrder_title')"></topNav>
    <div class="ordertop">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text"
               id='seachContent'
               v-model='searchOption.searchText'
               name=""
               :placeholder="$t('cateringOrder_search_placeholder')">
        <div class="cleartext"
             @click="searchOption.searchText='';getcateringList();"
             v-show="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
      </div>
      <div class="searchBtn"
           @click="getcateringList">{{ $t('search') }}
      </div>
      <span class="line"></span>
      <mt-button @click.native="popupVisible3 = true">
        <div class="fliter">{{ $t('fliter') }}<i class="iconfont icon-xia"></i>
          <span class='filter-red-dot'
                v-if='hasSelectFilter'></span>
        </div>
      </mt-button>
    </div>
    <div class="orderList">
      <div class="topd">
        <div class="left"
             v-if="view=='gant'">
          <div class="checkbox"
               v-for="(sta,index) in staColor"
               :key="'staColor' + index">
            <div class="dimetric"
                 :style="{background:sta.c}"></div>
            {{ sta.n }}
          </div>
        </div>

        <div class="right">
          <!-- 列表 甘特图 -->
          <switchbtn :ck='swith'
                     size='small'
                     ref="switch"
                     @change="switchChange"
                     :title1="$t('list')"
                     :title2="$t('gantt_chart')"></switchbtn>
        </div>
      </div>

      <template v-if="view == 'list'">
        <div class="tags clearfix">
          <div style="width: 3000px">
            <div class="tag"
                 @click="getList('')"
                 :class="{active:searchOption.pccode==''}"> {{ $t('all') }}
            </div>
            <div class="tag"
                 @click="getList(tab.code,index)"
                 :class="{active:searchOption.pccode==tab.code}"
                 v-for='(tab,index) in tabList'
                 :key="'tabList' + index">
              {{ tab.name }}
            </div>
          </div>
        </div>
        <ul class="list clearfix">
          <li class="item"
              v-for="(order, index) in orderList"
              :key="'orderList' + order.accnt + index">

            <div class="detailed">
              <div class="top clearfix">
                <p class="left">{{ $t('cateringOrder_accnt') }}：{{ order.accnt }}</p>
                <p class="right"
                   style="color:#FF6363">{{ sta[order.sta] }}</p>
              </div>
              <router-link :to="'/cateringDetail?id='+order.accnt">
                <div class="content clearfix">
                  <ul>
                    <li class="info">
                      {{ $t('cateringOrder_pccode') }}: {{ order.pccodeDes }}
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_linkMan') }}: {{ order.linkMan }}
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_resName') }}:{{ order.resName }}
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_tablenoDes') }}: {{ order.tablenoDes }}
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_phone') }}:
                      <a :href='"tel:"+order.phone'>{{ order.phone }}</a>
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_gsts') }}: {{ order.gsts }}
                    </li>
                    <li class="info">
                      {{ $t('cateringOrder_bizDate') }}:{{ order.bizDate | dateF }} {{ shift[order.shift] }}
                    </li>
                  </ul>
                  <i class="iconfont icon-you"></i>
                </div>
              </router-link>
            </div>
          </li>
          <nothing :condition="orderList != null && (orderList.length == undefined || orderList.length == 0)"></nothing>
        </ul>
      </template>

      <template v-if="view == 'gant'">
        <div class="spe-topd">
          <div class="topr">
            <table class="tbl"
                   v-if="dateRange.length > 0">
              <tr @click="backPccode">
                <!-- 场地 -->
                <td style="height:1.2rem;width:2rem;">{{ $t('site') }}&emsp;<i class="iconfont icon-fanhui-" v-if="showTableNo"></i></td>
              </tr>
            </table>
            <div class="gtt"
                 id="theader">
              <table class="gant"
                     :style='{width:(dateRange.length * 4.8)+"rem"}'>
                <tr>
                  <template v-for="(d,index) in dateRange">
                    <td :key="'dateRange-d' + index"
                        class="std h"
                        colspan="4">{{ d.d | dm }}
                    </td>
                  </template>
                </tr>
                <tr>
                  <template v-for="(d,index) in dateRange">
                    <!-- 早班 -->
                    <td :key="'dateRange-morning' + index"
                        class="std h">
                      <div class="width-fix">早班</div>
                    </td>
                    <!-- 中班 -->
                    <td :key="'dateRange-afternoon' + index"
                        class="std h">
                      <div class="width-fix">中班</div>
                    </td>
                    <!-- 晚班 -->
                    <td :key="'dateRange-evening' + index"
                        class="std h">
                      <div class="width-fix">晚班</div>
                    </td>
                    <!-- 夜班 -->
                    <td :key="'dateRange-night' + index"
                        class="std h">
                      <div class="width-fix">夜班</div>
                    </td>
                  </template>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="list list2 clearfix gttab">
          <!-- needFix -->
          <table class="tbl">
            <tr v-for='(item,index) in selectplist'
                v-if="!showTableNo"
                :key="'selectplist1' + index" @click="selectPccode(item)">
              <td>{{ item.name }}</td>
            </tr>
            <tr v-for='(item,index) in selectPTlist'
                v-if="showTableNo"
                :key="index">
              <td>{{ item.name }}</td>
            </tr>
          </table>
          <div class="gtt"
               id="tbody">
            <table class="gant"
                   :style='{width:(dateRange.length * 4.5)+"rem"}'>
              <tr v-for='(item,index) in selectplist'
                  v-if="!showTableNo"
                  :key="'selectplist2' + index">
                <template v-for="(d,i2) in dateRange">
                  <td :key="'dateRange-i2' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.name+'s1'].sta)}"
                      v-if="d[item.name+'s1']"
                      @click="touchTd(d[item.name+'s1'],item.name,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.name + 's1']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-2' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.name+'s2'].sta)}"
                      v-if="d[item.name+'s2']"
                      @click="touchTd(d[item.name+'s2'],item.name,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.name + 's2']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-4' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.name+'s3'].sta)}"
                      v-if="d[item.name+'s3']"
                      @click="touchTd(d[item.name+'s3'],item.name,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.name + 's3']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-6' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.name+'s4'].sta)}"
                      v-if="d[item.name+'s4']"
                      @click="touchTd(d[item.name+'s4'],item.name,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.name + 's4']) }}</div>
                  </td>
                </template>
              </tr>
              <!-- 根据桌号来 -->
              <tr v-for='(item,index) in selectPTlist'
                  v-if="showTableNo"
                  :key="index">
                <template v-for="(d,i2) in dateTRange">
                  <td :key="'dateRange-i2' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.tableno+'s1'].sta)}"
                      v-if="d[item.tableno+'s1']"
                      @click="touchTd(d[item.tableno+'s1'],item.tableno,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.tableno + 's1']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-2' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.tableno+'s2'].sta)}"
                      v-if="d[item.tableno+'s2']"
                      @click="touchTd(d[item.tableno+'s2'],item.tableno,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.tableno + 's2']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-4' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.tableno+'s3'].sta)}"
                      v-if="d[item.tableno+'s3']"
                      @click="touchTd(d[item.tableno+'s3'],item.tableno,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.tableno + 's3']) }}</div>
                  </td>

                  <td :key="'dateRange-i2-6' + i2"
                      class="std"
                      :style="{background:getColorBySta(d[item.tableno+'s4'].sta)}"
                      v-if="d[item.tableno+'s4']"
                      @click="touchTd(d[item.tableno+'s4'],item.tableno,item.code,d, item)">
                    <div class="width-fix">{{ distd(d[item.tableno + 's4']) }}</div>
                  </td>
                </template>
              </tr>
            </table>
            <div style="height:2rem;display:block;"></div>
          </div>
        </div>
      </template>

    </div>
    <mt-popup v-model="popupVisible3"
              position="right"
              class="mint-popup-3 rightFliterBox"
              :modal="true">
      <div class="rightFliterBox">
        <div class="filter_title"><span class="title">{{ $t('fliter') }}</span>
          <mt-button @click.native="popupVisible3 = false"><i class="iconfont icon-cuowu"></i></mt-button>
        </div>

        <div class="fliter_item">
          <div class="category_name"><span> {{ $t('cateringOrder_shift') }}</span></div>
          <div class="category_list clearfix twocol">
            <div v-for='(value,key) in shift'
                 :key="'shift' + key">
              <div class="option oplist"
                   :class='{checked:key==searchOption.shift}'
                   @click='selectSelf("shift",key)'>{{ value }}
              </div>
            </div>
          </div>
        </div>

        <div class="fliter_item">
          <div class="category_name"><span> {{ $t('cateringOrder_pccode') }}</span></div>
          <div class="category_list clearfix twocol">
            <div v-for='tab in tabList'
                 :key="'tabListcode' + tab.code">
              <div class="option oplist"
                   :class='{checked:tab.code==searchOption.pccode}'
                   @click='selectSelf("pccode",tab.code)'>{{ tab.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="fliter_item">
          <div class="category_name"><span>{{ $t('status') }}</span></div>
          <div class="category_list clearfix twocol">
            <div v-for='(item, index) in staObj'
                 :key="'staObj' + index">
              <div class="option oplist"
                   :class='{checked: staActive(item.code)}'
                   @click='selectStatus(item.code)'>
                {{ item.name }}
                <!--                {{item.code}}-->
              </div>
            </div>
          </div>
        </div>

        <div class="fliter_item">
          <div class="category_name"><span>{{ $t('cateringOrder_beginDate') }}</span></div>
          <div class="category_list clearfix ">
            <div class="option oplist"
                 style="width:3rem"
                 @click="openPick('picker')">{{ searchOption.beginDate | fdate }}
            </div>
            <div class="option oplist clearfix"
                 @click="searchOption.endDate=searchOption.beginDate"
                 style="width:1.5rem">{{ $t('eventWorm_today') }}
            </div>
          </div>
        </div>
        <div class="fliter_item">
          <div class="category_name"><span>{{ $t('cateringOrder_endDate') }}</span></div>
          <div class="category_list clearfix ">
            <div class="option oplist"
                 style="width:3rem"
                 @click="openPick('picker2')">{{ searchOption.endDate | fdate }}
            </div>

          </div>
        </div>

        <div class="bottom_f">
          <div class="reset"
               @click='reset'> {{ $t('reset') }}
          </div>
          <div class="success"
               @click='sendData'> {{ $t('complete') }}
          </div>
        </div>
      </div>
    </mt-popup>
    <mt-datetime-picker ref="picker"
                        type="date"
                        @confirm="handleConfirm"
                        :startDate="minDate"
                        :endDate="maxDate"
                        v-model="searchOption.beginDate"></mt-datetime-picker>
    <mt-datetime-picker ref="picker2"
                        type="date"
                        :startDate="minDate2"
                        :endDate="maxDate"
                        v-model="searchOption.endDate"></mt-datetime-picker>


    <div class="mul-model" v-if="showGantModal">
      <div class="mask"></div>

      <div class="container">
        <div class="header">
          <span>订单列表</span>
          <i class="iconfont icon-cuowu" @click="closeGantModal"></i>
        </div>
        <div class="order-list">
          <div class="order-list-item" :key="'tempArr' + index" v-for="(order, index) in tempArr">
            <div class="top clearfix">
              <p class="left">{{ $t('cateringOrder_accnt') }}：{{ order.accnt }}</p>
              <p class="right"
                 style="color:#FF6363">{{ sta[order.sta] }}</p>
            </div>
            <router-link :to="'/cateringDetail?id='+order.accnt">
              <div class="content clearfix">
                <ul>
                  <li class="info">
                    营业点: {{ order.pccodeDes }}
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_linkMan') }}: {{ order.linkMan }}
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_resName') }}:{{ order.resName }}
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_tablenoDes') }}: {{ order.tablenoDes }}
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_phone') }}:
                    <a :href='"tel:"+order.phone'>{{ order.phone }}</a>
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_gsts') }}: {{ order.gsts }}
                  </li>
                  <li class="info">
                    {{ $t('cateringOrder_bizDate') }}:{{ order.bizDate | dateF }} {{ shift[order.shift] }}
                  </li>
                </ul>
                <i class="iconfont icon-you"></i>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>


    <div class="addevent"
         @click='goCateringCreate'>
      <i class="iconfont icon-jia"></i>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import nothing from "../../common/nothing";
import {Toast} from "mint-ui";
import switchbtn from "../../common/switch";

export default {
  data() {
    return {
      view: 'list',
      swith: true,
      dateRange: [],
      dateTRange: [], // 桌号维度甘特图
      tabList: [],
      orderList: null,
      searchOption: {
        searchText: "",
        pccode: "",
        shift: "",
        beginDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(1, "M").format("YYYY-MM-DD"),
        sta: 'R,I,G',
      },
      minDate: moment(moment().format("YYYY-MM-DD")).toDate(),
      minDate2: moment(moment().format("YYYY-MM-DD")).toDate(),
      maxDate: moment(moment().add(24, "M").format("YYYY-MM-DD")).toDate(),
      shift: {
        1: this.$t('cateringOrder_shift_1'),
        2: this.$t('cateringOrder_shift_2'),
        3: this.$t('cateringOrder_shift_3'),
        4: this.$t('cateringOrder_shift_4'),
      },
      sta: {
        R: this.$t('cateringOrder_shift_R'),
        I: this.$t('cateringOrder_shift_I'),
        G: this.$t('cateringOrder_shift_C'),
        N: this.$t('cateringOrder_shift_N'),
        X: this.$t('cateringOrder_shift_X'),
      },
      staObj: [
        {code: 'R', name: this.$t('cateringOrder_shift_R')},
        {code: 'I', name: this.$t('cateringOrder_shift_I')},
        {code: 'G', name: this.$t('cateringOrder_shift_C')},
        {code: 'N', name: this.$t('cateringOrder_shift_N')},
        {code: 'X', name: this.$t('cateringOrder_shift_X')},
      ],
      staColor: [
        {s: "R", n: this.$t("cateringOrder_shift_R"), c: "#00ff00"},
        {s: "I", n: this.$t("cateringOrder_shift_I"), c: "#1c86ee"},
        {s: "G", n: this.$t("cateringOrder_shift_C"), c: "#8b7500"},
        {s: "N", n: this.$t("cateringOrder_shift_N"), c: "#8b4726"},
        {s: "X", n: this.$t("cateringOrder_shift_X"), c: "#ff0000"}
      ],
      popupVisible3: false,


      // 甘特图弹框
      tempArr: [],
      showGantModal: false,
      showTableNo: false, // 甘特图是营业点级别还是具体的某个营业点下的桌号级别
      selectPTlist: []
    };
  },
  computed: {
    hasSelectFilter: function () {
      let flag = false
      let searchOption = this.searchOption || {}
      for (var key in searchOption) {
        if (key != 'searchText' && searchOption[key]) {
          flag = true
        }
      }
      return flag
    },
    selectplist: {
      get() {
        var sp = this.searchOption.pccode;
        if (sp) {
          let ret = [];
          this.tabList.map((item2) => {
            if (item2.code == sp) {
              ret.push(item2);
            }
          })
          return ret;
        } else {
          console.log(this.tabList,"selectplist");
          return this.tabList;
        }
      }
    },

  },
  mounted() {
    /*获取餐厅列表*/
    this.$http.get("/mobilepmsapi/reception/getPosPcCode").then(res => {
      if (res.data.result == 0) {
        this.tabList = res.data.retVal;
      }
    });
    this.getLocalSearchOption()
    this.getcateringList();
  },

  methods: {
    distd(data) {
      if (data) {
        var title = data.title;
        if (title.length > 5) {
          title = title.substr(0, 4) + "..";
        }
        if (data.ids.length > 1) {
          title += "【" + data.ids.length + "】";
        }
        return title;
      }
      return "";
    },
    touchTd(data, tab, kv, d, item) {
      var ids = data.ids || []
      this.showGantModal = false
      this.tempArr = []
      if (ids.length > 0) {
        if (ids.length == 1) {
          this.goDetail(ids[0])
        } else {
          this.showGantModal = true
          this.tempArr = ids || []
        }
      } else {
        var date = moment(d.d).format('YYYY-MM-DD')
        var pccode = item.code || ''
        this.$router.push("/cateringCreate?date=" + date + '&pccode=' + pccode + '&from=gant')
      }
    },
    closeGantModal() {
      this.showGantModal = false
      this.tempArr = []
    },

    goDetail(item) {
      this.$router.push('/cateringDetail?id=' + item.id)
    },

    getColorBySta(sta) {
      for (var i = 0; i < this.staColor.length; i++) {
        if (this.staColor[i].s == sta) {
          return this.staColor[i].c;
        }
      }
      return "";
    },
    switchChange(v) {
      this.view = v ? "list" : "gant";
      // localStorage.setItem("cateringView", this.view);
      this.showTableNo = false;
      this.getcateringList();
    },
    staActive(code) {
      var searchOption = this.searchOption || {}
      var sta = searchOption.sta || ''
      var arr = sta.split(',')
      return arr.indexOf(code) > -1
    },

    selectStatus(v) {
      var searchOption = this.searchOption || {}
      var sta = searchOption.sta || ''
      var arr = []
      if (sta) {
        arr = sta.split(',')
      }
      if (arr.indexOf(v) > -1) {
        var index = arr.indexOf(v)
        arr.splice(index, 1)
      } else {
        arr.push(v)
      }
      var str = arr.join(',')
      this.searchOption.sta = str
    },

    goCateringCreate() {
      this.$router.push("/cateringCreate?redirect=/cateringOrder")
    },
    getLocalSearchOption() {
      let cateringOrderSearchOptions = this.$userLocal.getCateringOrderSearchOptions()
      if (cateringOrderSearchOptions) {
        let tempOption = JSON.parse(cateringOrderSearchOptions) || {}
        if (tempOption) {
          // 如果之前设置的结束日期小于今天，直接重置为默认值
          if (moment(tempOption.endDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) {
            tempOption.beginDate = moment().format("YYYY-MM-DD")
            tempOption.endDate = moment().add(1, "M").format("YYYY-MM-DD")
          }
          this.searchOption = tempOption
          // 这里默认的月份会少1个月，并且日期会被重置为1号，是什么bug TODO
          this.searchOption.beginDate = moment(this.searchOption.beginDate).format("YYYY-MM-DD")
          this.searchOption.endDate = moment(this.searchOption.endDate).format("YYYY-MM-DD")
          this.searchOption.searchText = ''
          this.searchOption.sta = tempOption.sta || ''
        } else {
          this.searchOption.sta = 'R,I,G'
        }
      } else {
        this.searchOption.sta = 'R,I,G'
      }
    },

    setLocalSearchOption() {
      this.$userLocal.setCateringOrderSearchOptions(JSON.stringify(this.searchOption))
    },

    /*获取列表信息*/
    getcateringList() {
      this.setLocalSearchOption()
      this.$http.post("/mobilepmsapi/reception/getPosResList", this.searchOption)
        .then(res => {
          if (res.data.result == 0) {
            this.orderList = res.data.retVal;

            if (this.view == "gant") {
              var sp = {
                beginDate: moment(this.searchOption.beginDate).format("YYYY-MM-DD"),
                endDate: moment(this.searchOption.endDate).format("YYYY-MM-DD"),
              }
              this.setRange(sp);
              this.setscroll();
            }
          } else {
            this.msg2(res.data.msg);
          }
        });
    },

    setscroll() {
      document.getElementById("tbody").addEventListener("scroll", this.bodyscroll);
      document.getElementById("theader").addEventListener("scroll", this.headscroll);
    },
    bodyscroll() {
      document.getElementById("theader").scrollLeft = document.getElementById("tbody").scrollLeft;
    },
    headscroll() {
      document.getElementById("theader").scrollLeft = document.getElementById("tbody").scrollLeft;
    },
    setRange(sp) {
      var start = moment(sp.beginDate).toDate().getTime();
      var end = moment(sp.endDate).add(1, "day").toDate().getTime();
      this.dateRange = [];
      while (start < end) {
        var p = {
          d: start
        };
        _.forEach(this.tabList, (item) => {
          var el = item.name
          p[el + "s1"] = {title: "", choiced: false, ids: []};
          p[el + "s2"] = {title: "", choiced: false, ids: []};
          p[el + "s3"] = {title: "", choiced: false, ids: []};
          p[el + "s4"] = {title: "", choiced: false, ids: []};
        });
        _.forEach(this.orderList, (el, key) => {
          var place = el.pccodeDes;
          var ov = el
          ov.id = el.accnt
          ov.rId = el.accnt
          ov.n = el.resName || ''
          var b = moment(el.bizDate).toDate().getTime();
          var isInDate = (b >= start) && (b <= (start + 86399999))
          if (el.shift && isInDate) {
            var str = place + "s" + el.shift
            if (p[str]) {
              (p[str].title = el.resName),
                (p[str].sta = el.sta),
                p[str].ids.push(ov);
            } else {
              p[str] = {
                title: el.resName,
                ids: [],
                sta: el.sta
              };
            }
          }
        });
        this.dateRange.push(p);
        start += 86400000; // +1天的时间
      }
    },
    // 选中一个甘特图中的营业点
    selectPccode(info){
      // 请求营业点对应的单号列表，然后桌号提取出来
      this.showTableNo = true;
      let tableList = [];
      this.orderList.filter(item => item.pccode == info.code).forEach(item => {
        if(!item.tableno){
          tableList.push({name: '/',tableno: '',accnt: item.accnt,code: item.pccode})
        }else{
          if(tableList.findIndex(item2 => item2.tableno == item.tableno) == -1){
            tableList.push({name: item.tablenoDes,tableno: item.tableno,accnt: item.accnt,code: item.pccode})
          }
        }
      })
      this.selectPTlist = tableList;
      // 桌号维度右边的数据拼凑
      var start = moment(moment(this.searchOption.beginDate).format("YYYY-MM-DD")).toDate().getTime();
      var end = moment(moment(this.searchOption.endDate).format("YYYY-MM-DD")).add(1, "day").toDate().getTime();
      this.dateTRange = [];
      while (start < end) {
        var p = {
          d: start
        };
        this.selectPTlist.forEach((item,index) => {
          // 由于有些是没有的桌号提前生成了预订单，所以不适合用桌名，用订单号
          p[item.tableno + "s1"] = {title: "", choiced: false, ids: []};
          p[item.tableno + "s2"] = {title: "", choiced: false, ids: []};
          p[item.tableno + "s3"] = {title: "", choiced: false, ids: []};
          p[item.tableno + "s4"] = {title: "", choiced: false, ids: []};
        })
        _.forEach(this.orderList, (el, key) => {
          var ov = el
          ov.id = el.accnt
          ov.rId = el.accnt
          ov.n = el.resName || ''
          var b = moment(el.bizDate).toDate().getTime();
          var isInDate = (b >= start) && (b <= (start + 86399999))
          if (el.shift && isInDate) {
            var str = el.tableno + "s" + el.shift
            if (p[str]) {
              console.log(el.resName);
              (p[str].title = el.resName),
                (p[str].sta = el.sta),
                p[str].ids.push(ov);
            }
          }
        });
        this.dateTRange.push(p);
        start += 86400000; // +1天的时间
        // console.log(this.dateTRange,"啦啦啦");
      }

    },
    backPccode(){
      this.showTableNo = false;
    },
    selectSelf(node, v) {
      if (this.searchOption[node] == v) {
        this.searchOption[node] = "";
      } else {
        this.searchOption[node] = v;
      }
    },
    openPick(p) {
      this.$refs[p].open();
    },
    handleConfirm(d) {
      this.minDate2 = moment(this.searchOption.beginDate).toDate();
      if (
        moment(this.searchOption.endDate) < moment(this.searchOption.beginDate)
      ) {
        this.searchOption.endDate = moment(this.searchOption.beginDate).format(
          "YYYY-MM-DD"
        );
      }
    },
    reset() {
      this.searchOption.shift = "";
      this.searchOption.pccode = "";
      this.searchOption.searchText = "";
      this.searchOption.sta = "R,I,G";
      this.searchOption.beginDate = moment().format("YYYY-MM-DD");
      this.searchOption.endDate = moment().add(1, "M").format("YYYY-MM-DD");
    },
    sendData() {
      this.popupVisible3 = false;
      // 重新到看营业点的甘特图
      this.showTableNo = false;
      this.getcateringList();
    },
    //点击事件，导航点中的标题居中
    getList(value, index) {
      this.searchOption.pccode = value;
      var numberIndex = index;
      if (numberIndex < 2 || this.searchOption.pccode == "") {
        document.getElementsByClassName("tags")[0].scrollLeft = 0;
      } else if (numberIndex < this.tabList.length - 3) {
        document.getElementsByClassName("tags")[0].scrollLeft =
          (numberIndex - 1) * 80;
      }
      if (numberIndex == this.tabList.length - 3) {
        document.getElementsByClassName("tags")[0].scrollLeft =
          (numberIndex - 1) * 80 + 40;
      }
      this.getcateringList();
    },
  },
  filters: {
    dateF(value) {
      return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
    },
    fdate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    dm(v) {
      var weekarr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      return moment(v).format("MM/DD ") + weekarr[moment(v).day()];
    },
  },
  beforeRouteLeave(to, from, next) {
    var e = document.getElementById("tbody");
    if (e) {
      e.removeEventListener("scroll", this.bodyscroll);
    }
    e = document.getElementById("theader");
    if (e) {
      e.removeEventListener("scroll", this.headscroll);
    }
    next();
  },
  components: {
    nothing, switchbtn
  }
};
</script>
<style lang='less'
       scoped>
.cateringOrder {
  background: #f7f8fa;

  .width-fix {
    width: 1.2rem;
  }

  .mul-model {
    .mask {
      background: rgba(0, 0, 0, 0.5);
      position: fixed;
      z-index: 10011;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    .container {
      background: #fff;
      width: 90%;
      z-index: 10012;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 5px;

      .header {
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        border-bottom: 2px solid #ddd;
        font-size: 17px;
        .iconfont {
          position: absolute;
          top: 0px;
          right: 15px;
          color: #666;
        }
      }
    }

    .order-list {
      height: 60vh;
      overflow: scroll;
      padding: 0 10px;
      box-sizing: border-box;

      .order-list-item {
        width: 100%;
        line-height: 14px;
        font-size: 12px;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        margin-bottom: 5px;

        .top {
          padding: 6px 8px;
          border-bottom: 1px dashed #ddd;

          .left {
            float: left;
          }

          .right {
            float: right;

            span {
              color: #d0011b;
            }
          }
        }

        .content {
          position: relative;

          .info {
            color: #333;
            float: left;
            box-sizing: border-box;
            height: 22px;
            line-height: 22px;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            a {
            }
          }

          .info:nth-of-type(2n-1) {
            width: 50%;
            padding-left: 13px;
          }

          .info:nth-of-type(2n) {
            width: 50%;
          }

          .iconfont {
            position: absolute;
            right: 6px;
            top: ~"calc(50% - 6px)";
            color: #9b9b9b;
          }
        }
      }
    }
  }


  .addevent {
    position: absolute;
    bottom: 70px;
    right: 40px;
    width: 45px;
    height: 46px;
    border-radius: 50%;
    background: #ff8000;
    color: #fff;
    line-height: 53px;
    text-align: center;
    z-index: 10;

    .iconfont {
      line-height: 45px;
      font-size: 20px;
    }
  }

  .ordertop {
    height: 1.28rem;
    width: 100%;
    background: #fff;
    padding: 0.18666667rem 0;
    box-sizing: border-box;
    position: absolute;
    z-index: 2000;
    display: flex;
    align-items: center;

    .line {
      float: left;
      width: 0.02666667rem;
      height: 0.53333333rem;
      background-color: #ccc;
    }

    .searct_btn {
      width: 1.73333333rem;
      box-sizing: border-box;
      text-align: left;
      float: left;
      height: 100%;
      font-size: 0.32rem;
      line-height: 0.89333333rem;
      color: #5b5b5b;
      padding-left: 0.33333333rem;
    }

    .mint-button {
      height: 100%;
      background: #fff;
      box-shadow: none;
      padding: 0;

      .fliter {
        width: 1.86666667rem;
        float: left;
        font-size: 0.32rem;
        line-height: 0.89333333rem;
        text-align: right;
        box-sizing: border-box;
        color: #5b5b5b;
        position: relative;

        .iconfont {
          display: inline-block;
          margin-left: 0.13333333rem;
        }

        .filter-red-dot {
          position: absolute;
          top: 0.25rem;
          right: 0.42rem;
          background: #ff471d;
          width: 6px;
          height: 6px;
          border-radius: 6px;
        }
      }
    }

    .search {
      margin-left: 0.34666667rem;
      border-radius: 0.44rem;
      width: 5.8rem;
      float: left;
      height: 0.85333333rem;
      background-color: #f7f8fa;
      padding: 0 0.26666667rem;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      i.icon-sousuo {
        vertical-align: bottom;
        font-size: 0.42666667rem;
        color: #ccc;
        line-height: 0.89333333rem;
      }

      input {
        padding-left: 0.2rem;
        width: 4.4rem;
        vertical-align: middle;
        //margin-bottom: 0.13333rem;
        flex: 1;
        height: 0.62666667rem;
        background-color: #f7f8fa;
        outline: 0;
        border: 0;
      }

      .cleartext {
        float: right;
        display: block;

        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #c3c3c3;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13333333rem;
          margin-top: 0.13333333rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }

    .searchBtn {
      width: 1.73333333rem;
      text-align: center;
      float: left;
      line-height: 0.85333333rem;
      font-size: 0.32rem;
      color: #333333;
    }
  }

  .orderList {
    margin-top: 1.4133rem;
    padding: 0 5px;

    .tags {
      height: 34px;
      width: 100%;
      overflow-x: auto;
      background-color: #fff;
      border-bottom: 5px solid #f7f8fa;

      &::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }

      .tag {
        float: left;
        position: relative;
        padding: 0 10px;
        height: 20px;
        text-align: center;
        font-size: 12px;
        color: #333;
        padding-top: 11px;

        &.active:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          /*width: 30px;*/
          height: 3px;
          background-color: #f69c2d;
          margin: 0 auto;
        }
      }
    }

    .list {
      height: ~"calc(100vh - 4.88rem)";
      overflow: scroll;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 80px;

      .item {
        &:first-child {
          margin-top: -12px;
        }

        .detailed {
          width: 100%;
          margin: 12px auto 0;
          line-height: 14px;
          font-size: 12px;
          background-color: #fff;

          .top {
            padding: 6px 8px;
            border-bottom: 1px dashed #ddd;
            border-top: 3px solid #d2d6de;

            .left {
              float: left;
            }

            .right {
              float: right;

              span {
                color: #d0011b;
              }
            }
          }

          .content {
            position: relative;

            .info {
              color: #333;
              float: left;
              box-sizing: border-box;
              height: 22px;
              line-height: 22px;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              a {
              }
            }

            .info:nth-of-type(2n-1) {
              width: 50%;
              padding-left: 13px;
            }

            .info:nth-of-type(2n) {
              width: 50%;
            }

            .iconfont {
              position: absolute;
              right: 6px;
              top: ~"calc(50% - 6px)";
              color: #9b9b9b;
            }
          }
        }
      }
    }

    .gttab {
      position: relative;
      margin-bottom: 1rem;

      .gtt {
        position: absolute;
        top: 0;
        left: 2rem;
        overflow: auto;
        width: 7.78rem;

        .gant {
          text-align: center;
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;

          td {
            height: 1.2rem;
            border-top: 1px solid #ccc;
            border-left: 1px solid #ccc;
            box-sizing: border-box;
            font-size: 0.28rem;
            word-break: break-all;
            position: relative;
          }

          .h {
            height: 0.6rem;
          }

          .ttd {
            width: 6rem;
          }

          .std {
            width: 1.5rem;

            &:active {
              background: #eaeaea;
            }
          }

          .name {
            width: 1.5rem;
          }
        }
      }

      .tbl {
        position: absolute;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        top: 0;
        left: 0;
        text-align: center;

        td {
          height: 1.2rem;
          font-size: 0.28rem;
          width: 2rem;
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          box-sizing: border-box;
        }
      }
    }

    .multChoice {
      position: absolute;
      width: 100%;
      height: 1.2rem;
      top: 0;
      left: 0;

      .mult-cicle {
        display: none;
        position: absolute;
        border-radius: 50%; // border: 1px #f7f8fa solid;
        box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
        background: #1470df;
        right: 7px; // left: 0;
        // top: 0;
        bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
        width: 20px;
        height: 20px;
        text-align: center;

        .iconfont {
          color: #fff;
        }
      }

      &.choiced {
        background-color: rgba(0, 0, 0, 0);

        .mult-cicle {
          display: block;

          .iconfont {
            text-align: center;
            line-height: 20px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }

    .spe-topd {
      width: 100%;
      overflow: hidden;
      position: fixed;
      top: 3.7rem;
      left: 0.1rem;

      .checkbox {
        display: inline-block;
        text-align: left;
        height: 0.6rem;
        line-height: 0.6rem;
        width: 1.65rem;
        font-size: 0.28rem;

        .dimetric {
          width: 0.33333333rem;
          height: 0.33333333rem;
          margin-right: 0.08rem;
          float: left;
          border-radius: 0.1rem;
          margin-top: 0.08rem;
          background: #fff;
        }
      }

      .left {
        float: left;
        width: 5rem;
      }

      .right {
        float: right;
        margin-right: 0.8rem;
        margin-bottom: 0.2rem;
      }

      .topr {
        position: relative;
        width: 100%;
        clear: both;
        height: 1.223rem;

        .tbl {
          position: absolute;
          left: 0;
          top: 0;
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
          text-align: center;

          td {
            height: 0.6rem;
            width: 1.5rem;
            border-top: 1px solid #ccc;
            border-left: 1px solid #ccc;
            box-sizing: border-box;
          }
        }

        .gtt {
          position: absolute;
          top: 0;
          left: 2rem;
          overflow: scroll;
          width: 7.78rem;

          .gant {
            text-align: center;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;

            td {
              height: 1.2rem;
              border-top: 1px solid #ccc;
              border-left: 1px solid #ccc;
              box-sizing: border-box;
            }

            .h {
              height: 0.6rem;
            }

            .ttd {
              width: 4.5rem;
            }

            .std {
              width: 1.5rem;

              &:active {
                background: #eaeaea;
              }
            }

            .name {
              width: 1.5rem;
            }
          }
        }
      }
    }

    .list2 {
      height: ~"calc(100% - 4.88rem)" !important;
      position: fixed;
      top: 4.88rem !important;
      left: 0.1rem;
    }
  }

  .mint-popup-3 {
    width: 6.13333333rem;
    height: 100%;

    .rightFliterBox {
      overflow: auto;
      width: 6.13333333rem;
      height: 100%;
      top: 0;
      background-color: #fff;
      transition: right 0.5s ease-in-out;
      box-shadow: 0 0.02666667rem 0.4rem #464444;

      .filter_title {
        width: 100%;
        height: 1.2rem;

        .title {
          float: left;
          line-height: 1.2rem;
          font-size: 0.4rem;
          margin-left: 0.4rem;
        }

        .mint-button {
          float: right;
          height: 100%;
          background: #fff;
          box-shadow: none;

          .icon-cuowu {
            float: right;
            margin-right: 0.4rem;
            line-height: 1.2rem;
            font-size: 0.4rem;
          }
        }
      }

      .fliter_item {
        margin-top: 0.4rem;
        padding: 0 0.26666667rem;

        &:nth-last-of-type(2) .category_list {
          border-bottom: 1.33333333rem solid #fff;
          /*padding-bottom: 1.33333333rem;*/
        }

        .category_name {
          height: 0.33333333rem;
          margin: 0 0.26666667rem 0.06666667rem;

          span {
            font-size: 0.26666667rem;
            color: #9b9b9b;
          }
        }

        .category_list {
          padding: 0.26666667rem 0 0.13333333rem;
          border-bottom: 0.02666667rem solid #efefef;

          .option {
            font-size: 0.33333333rem;
            width: 1.6rem;
            margin: 0px 0.13333333rem 0.26666667rem;
            float: left;
            border-radius: 0.10666667rem;
            background-color: #efefef;
            color: #606060;
            text-align: center;
            line-height: 0.69333333rem;
            overflow: hidden;
            height: 0.69333333rem;
          }

          & .checked {
            background-color: #f98f3c;
            color: #fff;
          }

          &.twocol {
            .option {
              width: 2.53333333rem;
              color: #333333;
            }
          }
        }
      }

      .bottom_f {
        position: fixed;
        width: 6.13333333rem;
        bottom: 0;
        height: 1.2rem;
        padding: 0.26666667rem 0;
        box-sizing: border-box;
        color: #fff;
        background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
        background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
        background-image: linear-gradient(to left, #ff5a51, #ffa500);

        .reset {
          float: left;
          text-align: center;
          font-size: 0.42666667rem;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          width: 50%;
          box-sizing: border-box;
          border-right: 0.02666667rem solid #fff;
        }

        .success {
          float: left;
          width: 50%;
          line-height: 0.66666667rem;
          height: 0.66666667rem;
          text-align: center;
          font-size: 0.42666667rem;
        }
      }
    }
  }
}

.cateringOrder .clearfix:after {
  content: "";
}

.topd {
  width: 100%;
  overflow: hidden;
  .left {
    float: left;
    width: 4.5rem;
  }

  .checkbox {
    display: inline-block;
    text-align: left;
    height: 0.6rem;
    line-height: 0.6rem;
    width: 1.35rem;
    font-size: 0.28rem;

    .dimetric {
      width: 0.33333333rem;
      height: 0.33333333rem;
      margin-right: 0.08rem;
      float: left;
      border-radius: 0.1rem;
      margin-top: 0.12rem;
      background: #fff;
    }
  }

  .right {
    float: right;
    margin-right: 0.8rem;
    margin-bottom: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// cateringOrder.vue?451ab314